import React from "react";
import { Link } from "react-router-dom";
import calls from "apis/calls";
import { useEffect , useState } from "react";
function Dashboard() {

  const [address,setAddress] = useState('')
  const [balance,setBalance] = useState('')
  const [to,setto] = useState('')
  const [amount,setamount] = useState('')

  const onchangHandler_to = (e) => {
    setto(e.target.value);
  };
  const onchangHandler_amount = (e) => {
    setamount(e.target.value);
  };
  const onchangHandler_send = async (e) => {
    await calls.transfer(to,amount)
  };

  console.log(amount , to)

  useEffect(async () => {
    setAddress(await calls.getwalletaddress())
    console.log(await calls.getBalance())
    setBalance(await calls.getBalance())
  }, []);

  return (
    <div>
      <div className="bg-img-main">
        <div className="bg-img"></div>
      </div>

      {/* ========================Home-Banner===================  */}
      <section id="banner">
        <div className="custom-container">
          <div className="sec-padding">
            <div className="row">
              <div className="col-lg-12">
                <div className="main">
                  <div className="box">
                    <div className="card">
                      <div className="card-body">
                        <h5 className="card-title">Your Wallet</h5>
                        <h6 className="card-subtitle mb-2 text-muted">
                          {address}
                        </h6>
                        <p className="card-text">
                          Some quick example text to build on the card title and
                          make up the bulk of the card's content.
                        </p>
                        <a href="#" className="card-link">
                          Total balance : {balance} ETH
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="box">
                    <span>TO</span>{" "}
                    <input
                      type="text"
                      className="wallet-address"
                      placeholder="Enter wallet address"
                      onChange={onchangHandler_to}
                    />
                  </div>
                  <div className="box">
                    <span>Amount</span>{" "}
                    <input
                      type="text"
                      className="wallet-address"
                      placeholder="Enter Amount in Eth"
                      onChange={onchangHandler_amount}
                    />
                  </div>
                  <div className="send-btn mt-5">
                    <Link to="#">
                      <button type="submit" className="btn w-100" onClick={onchangHandler_send}>
                        <span> Send</span>
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Dashboard;
